const ACTIONS = {
	// Virtual's
	VIEW_PAY_PLAN_ASSIGNMENTS: "VIEW_PAY_PLAN_ASSIGNMENTS",
	REVIEW_WASHOUT: "REVIEW_WASHOUT",

	// Individual
	VIEW_MY_PAY_PLANS: "VIEW_MY_PAY_PLANS",
	VIEW_MY_WASHOUTS: "VIEW_MY_WASHOUTS",
	VIEW_MY_MOTIVATORS: "VIEW_MY_MOTIVATORS",
	VIEW_MY_CIT_REPORTS: "VIEW_MY_CIT_REPORTS",
	VIEW_DASHBOARD: "VIEW_DASHBOARD",
	VIEW_USER_PROFILE: "VIEW_USER_PROFILE",
	VIEW_USER_PREFERENCES: "VIEW_USER_PREFERENCES",
	VIEW_HELP_CENTER: "VIEW_HELP_CENTER",
	VIEW_ORGANIZATION_CHART: "VIEW_ORGANIZATION_CHART",
	VIEW_COMMISSION_SUPPORT: "VIEW_COMMISSION_SUPPORT",
	VIEW_MY_CUSTOMER_SATISFACTION_SCORES: "VIEW_MY_CUSTOMER_SATISFACTION_SCORES",
	VIEW_MY_CALL_ACTIVITY: "VIEW_MY_CALL_ACTIVITY",
	VIEW_SALES_CUSTOMER_SATISFACTION: "VIEW_SALES_CUSTOMER_SATISFACTION",
	VIEW_SERVICE_CUSTOMER_SATISFACTION: "VIEW_SERVICE_CUSTOMER_SATISFACTION",
	VIEW_GPS_EMBEDDED_URL_BASIC_USER: "VIEW_GPS_EMBEDDED_URL_BASIC_USER",
	VIEW_GPS_EMBEDDED_URL_ADMIN_USER: "VIEW_GPS_EMBEDDED_URL_ADMIN_USER",

	// Administrative
	VIEW_USERS: "VIEW_USERS",
	VIEW_SALES_PERFORMANCE_REPORT_FORMATS: "VIEW_SALES_PERFORMANCE_REPORT_FORMATS",
	EDIT_SALES_PERFORMANCE_REPORT_FORMATS: "EDIT_SALES_PERFORMANCE_REPORT_FORMATS",
	VIEW_POSITION_MAPPINGS: "VIEW_POSITION_MAPPINGS",
	VIEW_PAY_ITEMS_MAPPING: "VIEW_PAY_ITEMS_MAPPING",
	EDIT_PAY_ITEMS_MAPPING: "EDIT_PAY_ITEMS_MAPPING",
	VIEW_CUSTOM_FIELD_ITEMS_MAPPING: "VIEW_CUSTOM_FIELD_ITEMS_MAPPING",
	EDIT_CUSTOM_FIELD_ITEMS_MAPPING: "EDIT_CUSTOM_FIELD_ITEMS_MAPPING",
	EDIT_POSITION_MAPPINGS: "EDIT_POSITION_MAPPINGS",
	VIEW_OTHER_USER_PROFILES: "VIEW_OTHER_USER_PROFILES",
	COMPARE_PAY_PLANS: "COMPARE_PAY_PLANS",
	PAY_PLAN_PROJECTION: "PAY_PLAN_PROJECTION",
	VIEW_ADMINISTRATION_TOOLS: "VIEW_ADMINISTRATION_TOOLS",
	VIEW_SYSTEM_SETTINGS: "VIEW_SYSTEM_SETTINGS",
	VIEW_COMMISSIONS_CYCLES_PER_MONTH: "VIEW_COMMISSIONS_CYCLES_PER_MONTH",
	EDIT_COMMISSIONS_CYCLES_PER_MONTH: "EDIT_COMMISSIONS_CYCLES_PER_MONTH",
	VIEW_CHARGEBACKS_LIMITS: "VIEW_CHARGEBACKS_LIMITS",
	EDIT_CHARGEBACKS_LIMITS: "EDIT_CHARGEBACKS_LIMITS",
	VIEW_WASHOUT_REVIEWERS: "VIEW_WASHOUT_REVIEWERS",
	EDIT_WASHOUT_REVIEWERS: "EDIT_WASHOUT_REVIEWERS",
	"EDIT_F&I_RANKING": "EDIT_F&I_RANKING",
	VIEW_TECHNICAL_CONTACTS: "VIEW_TECHNICAL_CONTACTS",
	EDIT_TECHNICAL_CONTACTS: "EDIT_TECHNICAL_CONTACTS",
	VIEW_MAX_ALLOWABLE_BORROWED_PTO: "VIEW_MAX_ALLOWABLE_BORROWED_PTO",
	EDIT_MAX_ALLOWABLE_BORROWED_PTO: "EDIT_MAX_ALLOWABLE_BORROWED_PTO",
	EDIT_STORE_PICTURES: "EDIT_STORE_PICTURES",
	VIEW_USER_ACCESS_SETTINGS: "VIEW_USER_ACCESS_SETTINGS",
	EDIT_USER_ACCESS_SETTINGS: "EDIT_USER_ACCESS_SETTINGS",
	VIEW_ACTION_GROUPS: "VIEW_ACTION_GROUPS",
	EDIT_ACTION_GROUPS: "EDIT_ACTION_GROUPS",
	EDIT_QUEUE_MAPPINGS: "EDIT_QUEUE_MAPPINGS",
	VIEW_QUEUE_MAPPINGS: "VIEW_QUEUE_MAPPINGS",
	VIEW_PTO_MODALITY: "VIEW_PTO_MODALITY",
	EDIT_PTO_MODALITY: "EDIT_PTO_MODALITY",
	EDIT_CIT_MAX_VALUES: "EDIT_CIT_MAX_VALUES",
	EDIT_DEALER_CODES: "EDIT_DEALER_CODES",
	EDIT_PVR_MAX_VALUES: "EDIT_PVR_MAX_VALUES",
	VIEW_FINANCIAL_STATEMENT_CONFIG: "VIEW_FINANCIAL_STATEMENT_CONFIG",
	EDIT_FINANCIAL_STATEMENT_CONFIG: "EDIT_FINANCIAL_STATEMENT_CONFIG",
	VIEW_OEM_FINANCIAL_STATEMENTS: "VIEW_OEM_FINANCIAL_STATEMENTS",
	// Pay Plans
	VIEW_BDC_ASSOCIATE_PAY_PLANS: "VIEW_BDC_ASSOCIATE_PAY_PLANS",
	VIEW_BDC_MANAGER_PAY_PLANS: "VIEW_BDC_MANAGER_PAY_PLANS",
	VIEW_BDC_DIRECTOR_PAY_PLANS: "VIEW_BDC_DIRECTOR_PAY_PLANS",
	VIEW_SALES_ASSOCIATE_PAY_PLANS: "VIEW_SALES_ASSOCIATE_PAY_PLANS",
	VIEW_FINANCE_MANAGER_PAY_PLANS: "VIEW_FINANCE_MANAGER_PAY_PLANS",
	VIEW_SALES_MANAGER_PAY_PLANS: "VIEW_SALES_MANAGER_PAY_PLANS",
	VIEW_GENERAL_SALES_MANAGER_PAY_PLANS: "VIEW_GENERAL_SALES_MANAGER_PAY_PLANS",
	VIEW_FINANCE_DIRECTOR_PAY_PLANS: "VIEW_FINANCE_DIRECTOR_PAY_PLANS",
	VIEW_GENERAL_MANAGER_PAY_PLANS: "VIEW_GENERAL_MANAGER_PAY_PLANS",
	VIEW_SERVICE_ADVISOR_PAY_PLANS: "VIEW_SERVICE_ADVISOR_PAY_PLANS",
	VIEW_INTERNAL_SERVICE_ADVISOR_PAY_PLANS: "VIEW_INTERNAL_SERVICE_ADVISOR_PAY_PLANS",
	VIEW_SERVICE_TECHNICIAN_PAY_PLANS: "VIEW_SERVICE_TECHNICIAN_PAY_PLANS",
	VIEW_BODY_SHOP_TECHNICIAN_PAY_PLANS: "VIEW_BODY_SHOP_TECHNICIAN_PAY_PLANS",
	VIEW_PARTS_COUNTER_ASSOCIATE_PAY_PLANS: "VIEW_PARTS_COUNTER_ASSOCIATE_PAY_PLANS",
	VIEW_PARTS_MANAGER_PAY_PLANS: "VIEW_PARTS_MANAGER_PAY_PLANS",
	VIEW_PARTS_DIRECTOR_PAY_PLANS: "VIEW_PARTS_DIRECTOR_PAY_PLANS",
	VIEW_SERVICE_MANAGER_PAY_PLANS: "VIEW_SERVICE_MANAGER_PAY_PLANS",
	VIEW_SERVICE_DIRECTOR_PAY_PLANS: "VIEW_SERVICE_DIRECTOR_PAY_PLANS",
	VIEW_SERVICE_FOREMAN_PAY_PLANS: "VIEW_SERVICE_FOREMAN_PAY_PLANS",
	VIEW_BODY_SHOP_PAINTER_PAY_PLANS: "VIEW_BODY_SHOP_PAINTER_PAY_PLANS",
	VIEW_BODY_SHOP_MANAGER_PAY_PLANS: "VIEW_BODY_SHOP_MANAGER_PAY_PLANS",
	VIEW_BODY_SHOP_PRODUCT_MANAGER_PAY_PLANS: "VIEW_BODY_SHOP_PRODUCT_MANAGER_PAY_PLANS",
	VIEW_BODY_SHOP_ESTIMATOR_PAY_PLANS: "VIEW_BODY_SHOP_ESTIMATOR_PAY_PLANS",
	VIEW_BODY_SHOP_DIRECTOR_PAY_PLANS: "VIEW_BODY_SHOP_DIRECTOR_PAY_PLANS",
	VIEW_BODY_SHOP_FOREMAN_PAY_PLANS: "VIEW_BODY_SHOP_FOREMAN_PAY_PLANS",
	VIEW_FIXED_OPERATIONS_DIRECTOR_PAY_PLANS: "VIEW_FIXED_OPERATIONS_DIRECTOR_PAY_PLANS",
	EDIT_BDC_ASSOCIATE_PAY_PLANS: "EDIT_BDC_ASSOCIATE_PAY_PLANS",
	EDIT_BDC_MANAGER_PAY_PLANS: "EDIT_BDC_MANAGER_PAY_PLANS",
	EDIT_BDC_DIRECTOR_PAY_PLANS: "EDIT_BDC_DIRECTOR_PAY_PLANS",
	EDIT_SALES_ASSOCIATE_PAY_PLANS: "EDIT_SALES_ASSOCIATE_PAY_PLANS",
	EDIT_FINANCE_MANAGER_PAY_PLANS: "EDIT_FINANCE_MANAGER_PAY_PLANS",
	EDIT_SALES_MANAGER_PAY_PLANS: "EDIT_SALES_MANAGER_PAY_PLANS",
	EDIT_GENERAL_SALES_MANAGER_PAY_PLANS: "EDIT_GENERAL_SALES_MANAGER_PAY_PLANS",
	EDIT_FINANCE_DIRECTOR_PAY_PLANS: "EDIT_FINANCE_DIRECTOR_PAY_PLANS",
	EDIT_GENERAL_MANAGER_PAY_PLANS: "EDIT_GENERAL_MANAGER_PAY_PLANS",
	EDIT_SERVICE_ADVISOR_PAY_PLANS: "EDIT_SERVICE_ADVISOR_PAY_PLANS",
	EDIT_INTERNAL_SERVICE_ADVISOR_PAY_PLANS: "EDIT_INTERNAL_SERVICE_ADVISOR_PAY_PLANS",
	EDIT_BODY_SHOP_ESTIMATOR_PAY_PLANS: "EDIT_BODY_SHOP_ESTIMATOR_PAY_PLANS",
	EDIT_SERVICE_TECHNICIAN_PAY_PLANS: "EDIT_SERVICE_TECHNICIAN_PAY_PLANS",
	EDIT_BODY_SHOP_TECHNICIAN_PAY_PLANS: "EDIT_BODY_SHOP_TECHNICIAN_PAY_PLANS",
	EDIT_PARTS_COUNTER_ASSOCIATE_PAY_PLANS: "EDIT_PARTS_COUNTER_ASSOCIATE_PAY_PLANS",
	EDIT_PARTS_MANAGER_PAY_PLANS: "EDIT_PARTS_MANAGER_PAY_PLANS",
	EDIT_PARTS_DIRECTOR_PAY_PLANS: "EDIT_PARTS_DIRECTOR_PAY_PLANS",
	EDIT_SERVICE_MANAGER_PAY_PLANS: "EDIT_SERVICE_MANAGER_PAY_PLANS",
	EDIT_SERVICE_DIRECTOR_PAY_PLANS: "EDIT_SERVICE_DIRECTOR_PAY_PLANS",
	EDIT_SERVICE_FOREMAN_PAY_PLANS: "EDIT_SERVICE_FOREMAN_PAY_PLANS",
	EDIT_BODY_SHOP_PAINTER_PAY_PLANS: "EDIT_BODY_SHOP_PAINTER_PAY_PLANS",
	EDIT_BODY_SHOP_MANAGER_PAY_PLANS: "EDIT_BODY_SHOP_MANAGER_PAY_PLANS",
	EDIT_BODY_SHOP_PRODUCT_MANAGER_PAY_PLANS: "EDIT_BODY_SHOP_PRODUCT_MANAGER_PAY_PLANS",
	EDIT_BODY_SHOP_FOREMAN_PAY_PLANS: "EDIT_BODY_SHOP_FOREMAN_PAY_PLANS",
	EDIT_BODY_SHOP_DIRECTOR_PAY_PLANS: "EDIT_BODY_SHOP_DIRECTOR_PAY_PLANS",
	EDIT_FIXED_OPERATIONS_DIRECTOR_PAY_PLANS: "EDIT_FIXED_OPERATIONS_DIRECTOR_PAY_PLANS",
	VIEW_BDC_ASSOCIATE_PAY_PLAN_ASSIGNMENTS: "VIEW_BDC_ASSOCIATE_PAY_PLAN_ASSIGNMENTS",
	VIEW_BDC_MANAGER_PAY_PLAN_ASSIGNMENTS: "VIEW_BDC_MANAGER_PAY_PLAN_ASSIGNMENTS",
	VIEW_BDC_DIRECTOR_PAY_PLAN_ASSIGNMENTS: "VIEW_BDC_DIRECTOR_PAY_PLAN_ASSIGNMENTS",
	VIEW_SALES_ASSOCIATE_PAY_PLAN_ASSIGNMENTS: "VIEW_SALES_ASSOCIATE_PAY_PLAN_ASSIGNMENTS",
	VIEW_FINANCE_MANAGER_PAY_PLAN_ASSIGNMENTS: "VIEW_FINANCE_MANAGER_PAY_PLAN_ASSIGNMENTS",
	VIEW_SALES_MANAGER_PAY_PLAN_ASSIGNMENTS: "VIEW_SALES_MANAGER_PAY_PLAN_ASSIGNMENTS",
	VIEW_GENERAL_SALES_MANAGER_PAY_PLAN_ASSIGNMENTS: "VIEW_GENERAL_SALES_MANAGER_PAY_PLAN_ASSIGNMENTS",
	VIEW_FINANCE_DIRECTOR_PAY_PLAN_ASSIGNMENTS: "VIEW_FINANCE_DIRECTOR_PAY_PLAN_ASSIGNMENTS",
	VIEW_GENERAL_MANAGER_PAY_PLAN_ASSIGNMENTS: "VIEW_GENERAL_MANAGER_PAY_PLAN_ASSIGNMENTS",
	VIEW_SERVICE_ADVISOR_PAY_PLAN_ASSIGNMENTS: "VIEW_SERVICE_ADVISOR_PAY_PLAN_ASSIGNMENTS",
	VIEW_INTERNAL_SERVICE_ADVISOR_PAY_PLAN_ASSIGNMENTS: "VIEW_INTERNAL_SERVICE_ADVISOR_PAY_PLAN_ASSIGNMENTS",
	VIEW_BODY_SHOP_ESTIMATOR_PAY_PLAN_ASSIGNMENTS: "VIEW_BODY_SHOP_ESTIMATOR_PAY_PLAN_ASSIGNMENTS",
	VIEW_SERVICE_TECHNICIAN_PAY_PLAN_ASSIGNMENTS: "VIEW_SERVICE_TECHNICIAN_PAY_PLAN_ASSIGNMENTS",
	VIEW_BODY_SHOP_TECHNICIAN_PAY_PLAN_ASSIGNMENTS: "VIEW_BODY_SHOP_TECHNICIAN_PAY_PLAN_ASSIGNMENTS",
	VIEW_PARTS_COUNTER_ASSOCIATE_PAY_PLAN_ASSIGNMENTS: "VIEW_PARTS_COUNTER_ASSOCIATE_PAY_PLAN_ASSIGNMENTS",
	VIEW_PARTS_MANAGER_PAY_PLAN_ASSIGNMENTS: "VIEW_PARTS_MANAGER_PAY_PLAN_ASSIGNMENTS",
	VIEW_PARTS_DIRECTOR_PAY_PLAN_ASSIGNMENTS: "VIEW_PARTS_DIRECTOR_PAY_PLAN_ASSIGNMENTS",
	VIEW_SERVICE_MANAGER_PAY_PLAN_ASSIGNMENTS: "VIEW_SERVICE_MANAGER_PAY_PLAN_ASSIGNMENTS",
	VIEW_SERVICE_DIRECTOR_PAY_PLAN_ASSIGNMENTS: "VIEW_SERVICE_DIRECTOR_PAY_PLAN_ASSIGNMENTS",
	VIEW_SERVICE_FOREMAN_PAY_PLAN_ASSIGNMENTS: "VIEW_SERVICE_FOREMAN_PAY_PLAN_ASSIGNMENTS",
	VIEW_BODY_SHOP_PAINTER_PAY_PLAN_ASSIGNMENTS: "VIEW_BODY_SHOP_PAINTER_PAY_PLAN_ASSIGNMENTS",
	VIEW_BODY_SHOP_MANAGER_PAY_PLAN_ASSIGNMENTS: "VIEW_BODY_SHOP_MANAGER_PAY_PLAN_ASSIGNMENTS",
	VIEW_BODY_SHOP_PRODUCT_MANAGER_PAY_PLAN_ASSIGNMENTS: "VIEW_BODY_SHOP_PRODUCT_MANAGER_PAY_PLAN_ASSIGNMENTS",
	VIEW_BODY_SHOP_DIRECTOR_PAY_PLAN_ASSIGNMENTS: "VIEW_BODY_SHOP_DIRECTOR_PAY_PLAN_ASSIGNMENTS",
	VIEW_BODY_SHOP_FOREMAN_PAY_PLAN_ASSIGNMENTS: "VIEW_BODY_SHOP_FOREMAN_PAY_PLAN_ASSIGNMENTS",
	VIEW_FIXED_OPERATIONS_DIRECTOR_PAY_PLAN_ASSIGNMENTS: "VIEW_FIXED_OPERATIONS_DIRECTOR_PAY_PLAN_ASSIGNMENTS",
	EDIT_BDC_ASSOCIATE_PAY_PLAN_ASSIGNMENTS: "EDIT_BDC_ASSOCIATE_PAY_PLAN_ASSIGNMENTS",
	EDIT_BDC_MANAGER_PAY_PLAN_ASSIGNMENTS: "EDIT_BDC_MANAGER_PAY_PLAN_ASSIGNMENTS",
	EDIT_BDC_DIRECTOR_PAY_PLAN_ASSIGNMENTS: "EDIT_BDC_DIRECTOR_PAY_PLAN_ASSIGNMENTS",
	EDIT_SALES_ASSOCIATE_PAY_PLAN_ASSIGNMENTS: "EDIT_SALES_ASSOCIATE_PAY_PLAN_ASSIGNMENTS",
	EDIT_FINANCE_MANAGER_PAY_PLAN_ASSIGNMENTS: "EDIT_FINANCE_MANAGER_PAY_PLAN_ASSIGNMENTS",
	EDIT_SALES_MANAGER_PAY_PLAN_ASSIGNMENTS: "EDIT_SALES_MANAGER_PAY_PLAN_ASSIGNMENTS",
	EDIT_GENERAL_SALES_MANAGER_PAY_PLAN_ASSIGNMENTS: "EDIT_GENERAL_SALES_MANAGER_PAY_PLAN_ASSIGNMENTS",
	EDIT_FINANCE_DIRECTOR_PAY_PLAN_ASSIGNMENTS: "EDIT_FINANCE_DIRECTOR_PAY_PLAN_ASSIGNMENTS",
	EDIT_GENERAL_MANAGER_PAY_PLAN_ASSIGNMENTS: "EDIT_GENERAL_MANAGER_PAY_PLAN_ASSIGNMENTS",
	EDIT_SERVICE_ADVISOR_PAY_PLAN_ASSIGNMENTS: "EDIT_SERVICE_ADVISOR_PAY_PLAN_ASSIGNMENTS",
	EDIT_INTERNAL_SERVICE_ADVISOR_PAY_PLAN_ASSIGNMENTS: "EDIT_INTERNAL_SERVICE_ADVISOR_PAY_PLAN_ASSIGNMENTS",
	EDIT_BODY_SHOP_ESTIMATOR_PAY_PLAN_ASSIGNMENTS: "EDIT_BODY_SHOP_ESTIMATOR_PAY_PLAN_ASSIGNMENTS",
	EDIT_SERVICE_TECHNICIAN_PAY_PLAN_ASSIGNMENTS: "EDIT_SERVICE_TECHNICIAN_PAY_PLAN_ASSIGNMENTS",
	EDIT_BODY_SHOP_TECHNICIAN_PAY_PLAN_ASSIGNMENTS: "EDIT_BODY_SHOP_TECHNICIAN_PAY_PLAN_ASSIGNMENTS",
	EDIT_PARTS_COUNTER_ASSOCIATE_PAY_PLAN_ASSIGNMENTS: "EDIT_PARTS_COUNTER_ASSOCIATE_PAY_PLAN_ASSIGNMENTS",
	EDIT_PARTS_MANAGER_PAY_PLAN_ASSIGNMENTS: "EDIT_PARTS_MANAGER_PAY_PLAN_ASSIGNMENTS",
	EDIT_PARTS_DIRECTOR_PAY_PLAN_ASSIGNMENTS: "EDIT_PARTS_DIRECTOR_PAY_PLAN_ASSIGNMENTS",
	EDIT_SERVICE_MANAGER_PAY_PLAN_ASSIGNMENTS: "EDIT_SERVICE_MANAGER_PAY_PLAN_ASSIGNMENTS",
	EDIT_SERVICE_DIRECTOR_PAY_PLAN_ASSIGNMENTS: "EDIT_SERVICE_DIRECTOR_PAY_PLAN_ASSIGNMENTS",
	EDIT_SERVICE_FOREMAN_PAY_PLAN_ASSIGNMENTS: "EDIT_SERVICE_FOREMAN_PAY_PLAN_ASSIGNMENTS",
	EDIT_BODY_SHOP_PAINTER_PAY_PLAN_ASSIGNMENTS: "EDIT_BODY_SHOP_PAINTER_PAY_PLAN_ASSIGNMENTS",
	EDIT_BODY_SHOP_MANAGER_PAY_PLAN_ASSIGNMENTS: "EDIT_BODY_SHOP_MANAGER_PAY_PLAN_ASSIGNMENTS",
	EDIT_BODY_SHOP_PRODUCT_MANAGER_PAY_PLAN_ASSIGNMENTS: "EDIT_BODY_SHOP_PRODUCT_MANAGER_PAY_PLAN_ASSIGNMENTS",
	EDIT_BODY_SHOP_DIRECTOR_PAY_PLAN_ASSIGNMENTS: "EDIT_BODY_SHOP_DIRECTOR_PAY_PLAN_ASSIGNMENTS",
	EDIT_BODY_SHOP_FOREMAN_PAY_PLAN_ASSIGNMENTS: "EDIT_BODY_SHOP_FOREMAN_PAY_PLAN_ASSIGNMENTS",
	EDIT_FIXED_OPERATIONS_DIRECTOR_PAY_PLAN_ASSIGNMENTS: "EDIT_FIXED_OPERATIONS_DIRECTOR_PAY_PLAN_ASSIGNMENTS",
	VIEW_HISTORICAL_ASSIGNMENTS: "VIEW_HISTORICAL_ASSIGNMENTS",

	// Washouts
	VIEW_BDC_ASSOCIATE_WASHOUTS: "VIEW_BDC_ASSOCIATE_WASHOUTS",
	VIEW_BDC_MANAGER_WASHOUTS: "VIEW_BDC_MANAGER_WASHOUTS",
	VIEW_BDC_DIRECTOR_WASHOUTS: "VIEW_BDC_DIRECTOR_WASHOUTS",
	VIEW_SALES_ASSOCIATE_WASHOUTS: "VIEW_SALES_ASSOCIATE_WASHOUTS",
	VIEW_FINANCE_MANAGER_WASHOUTS: "VIEW_FINANCE_MANAGER_WASHOUTS",
	VIEW_SALES_MANAGER_WASHOUTS: "VIEW_SALES_MANAGER_WASHOUTS",
	VIEW_GENERAL_SALES_MANAGER_WASHOUTS: "VIEW_GENERAL_SALES_MANAGER_WASHOUTS",
	VIEW_FINANCE_DIRECTOR_WASHOUTS: "VIEW_FINANCE_DIRECTOR_WASHOUTS",
	VIEW_GENERAL_MANAGER_WASHOUTS: "VIEW_GENERAL_MANAGER_WASHOUTS",
	VIEW_SERVICE_ADVISOR_WASHOUTS: "VIEW_SERVICE_ADVISOR_WASHOUTS",
	VIEW_INTERNAL_SERVICE_ADVISOR_WASHOUTS: "VIEW_INTERNAL_SERVICE_ADVISOR_WASHOUTS",
	VIEW_BODY_SHOP_ESTIMATOR_WASHOUTS: "VIEW_BODY_SHOP_ESTIMATOR_WASHOUTS",
	VIEW_SERVICE_TECHNICIAN_WASHOUTS: "VIEW_SERVICE_TECHNICIAN_WASHOUTS",
	VIEW_BODY_SHOP_TECHNICIAN_WASHOUTS: "VIEW_BODY_SHOP_TECHNICIAN_WASHOUTS",
	VIEW_PARTS_COUNTER_ASSOCIATE_WASHOUTS: "VIEW_PARTS_COUNTER_ASSOCIATE_WASHOUTS",
	VIEW_PARTS_MANAGER_WASHOUTS: "VIEW_PARTS_MANAGER_WASHOUTS",
	VIEW_PARTS_DIRECTOR_WASHOUTS: "VIEW_PARTS_DIRECTOR_WASHOUTS",
	VIEW_SERVICE_MANAGER_WASHOUTS: "VIEW_SERVICE_MANAGER_WASHOUTS",
	VIEW_SERVICE_DIRECTOR_WASHOUTS: "VIEW_SERVICE_DIRECTOR_WASHOUTS",
	VIEW_SERVICE_FOREMAN_WASHOUTS: "VIEW_SERVICE_FOREMAN_WASHOUTS",
	VIEW_BODY_SHOP_PAINTER_WASHOUTS: "VIEW_BODY_SHOP_PAINTER_WASHOUTS",
	VIEW_BODY_SHOP_MANAGER_WASHOUTS: "VIEW_BODY_SHOP_MANAGER_WASHOUTS",
	VIEW_BODY_SHOP_PRODUCT_MANAGER_WASHOUTS: "VIEW_BODY_SHOP_PRODUCT_MANAGER_WASHOUTS",
	VIEW_BODY_SHOP_DIRECTOR_WASHOUTS: "VIEW_BODY_SHOP_DIRECTOR_WASHOUTS",
	VIEW_BODY_SHOP_FOREMAN_WASHOUTS: "VIEW_BODY_SHOP_FOREMAN_WASHOUTS",
	VIEW_FIXED_OPERATIONS_DIRECTOR_WASHOUTS: "VIEW_FIXED_OPERATIONS_DIRECTOR_WASHOUTS",
	VIEW_COMMISSION_SUPPORT_TEAM: "VIEW_COMMISSION_SUPPORT_TEAM",
	EDIT_COMMISSION_SUPPORT_TEAM: "EDIT_COMMISSION_SUPPORT_TEAM",
	VIEW_SUPPORT_CENTER: "VIEW_SUPPORT_CENTER",

	// Application Data
	VIEW_SALES_PERFORMANCE_REPORTS: "VIEW_SALES_PERFORMANCE_REPORTS",
	EXPORT_CROSS_STORE_RECONCILIATION_REPORT: "EXPORT_CROSS_STORE_RECONCILIATION_REPORT",
	VIEW_CHARGEBACKS_REPORTS: "VIEW_CHARGEBACKS_REPORTS",
	UPLOAD_CHARGEBACKS_REPORT: "UPLOAD_CHARGEBACKS_REPORT",
	UPLOAD_OEM_REPORT: "UPLOAD_OEM_REPORT",
	SYNC_USERS: "SYNC_USERS",
	VIEW_SOCIAL_MEDIA_REVIEWS: "VIEW_SOCIAL_MEDIA_REVIEWS",
	SYNC_SOCIAL_MEDIA_REVIEWS: "SYNC_SOCIAL_MEDIA_REVIEWS",
	REPLY_REVIEWS: "REPLY_REVIEWS",
	SYNC_DRAW_AMOUNTS: "SYNC_DRAW_AMOUNTS",
	VIEW_CUSTOMER_SATISFACTION_SCORES: "VIEW_CUSTOMER_SATISFACTION_SCORES",
	VIEW_DRAW_AMOUNTS: "VIEW_DRAW_AMOUNTS",
	VIEW_PAY_RATES: "VIEW_PAY_RATES",
	SYNC_PAY_RATES: "SYNC_PAY_RATES",
	VIEW_TIME_AND_ATTENDANCE: "VIEW_TIME_AND_ATTENDANCE",
	SYNC_TIME_AND_ATTENDANCE: "SYNC_TIME_AND_ATTENDANCE",
	VIEW_SALES_LOG: "VIEW_SALES_LOG",
	VIEW_CIT_REPORTS: "VIEW_CIT_REPORTS",
	UPLOAD_CIT_REPORT: "UPLOAD_CIT_REPORT",
	VIEW_ALL_DEALS: "VIEW_ALL_DEALS",
	EXPORT_WRITE_OFF: "EXPORT_WRITE_OFF",
	VIEW_CUSTOMER_ENGAGEMENT_TRAIL: "VIEW_CUSTOMER_ENGAGEMENT_TRAIL",
	SYNC_CUSTOMER_ENGAGEMENT_TRAIL: "SYNC_CUSTOMER_ENGAGEMENT_TRAIL",
	VIEW_FINANCE_DEAL_DATA: "VIEW_FINANCE_DEAL_DATA",
	VIEW_FINANCE_DETAILS: "VIEW_FINANCE_DETAILS",
	VIEW_FINANCE_TRADES_PAYOFFS: "VIEW_FINANCE_TRADES_PAYOFFS",
	VIEW_FINANCE_TITLINGS: "VIEW_FINANCE_TITLINGS",
	VIEW_CALL_ACTIVITY_REPORTS: "VIEW_CALL_ACTIVITY_REPORTS",
	UPLOAD_CALL_ACTIVITY_REPORT: "UPLOAD_CALL_ACTIVITY_REPORT",
	VIEW_TECHNICIAN_FLAGGED_TIME: "VIEW_TECHNICIAN_FLAGGED_TIME",
	UPLOAD_TECHNICIAN_FLAGGED_TIME_REPORT: "UPLOAD_TECHNICIAN_FLAGGED_TIME_REPORT",
	VIEW_ADVISOR_PERFORMANCE: "VIEW_ADVISOR_PERFORMANCE",
	UPLOAD_ADVISOR_PERFORMANCE_REPORT: "UPLOAD_ADVISOR_PERFORMANCE_REPORT",
	VIEW_TIME_PAY_RATES_REPORTS: "VIEW_TIME_PAY_RATES_REPORTS",
	VIEW_INVENTORY: "VIEW_INVENTORY",
	VIEW_RECONCILIATION: "VIEW_RECONCILIATION",
	VIEW_DEALER_TRADES: "VIEW_DEALER_TRADES",
	EDIT_DEALER_TRADES: "EDIT_DEALER_TRADES",
	VIEW_DEALER_TRADES_INVOICE_COST: "VIEW_DEALER_TRADES_INVOICE_COST",
	VIEW_CANCELLATIONS: "VIEW_CANCELLATIONS",
	VIEW_REPAIR_ORDERS: "VIEW_REPAIR_ORDERS",
	EDIT_REPAIR_ORDERS: "EDIT_REPAIR_ORDERS",
	VIEW_SALES_LEADS: "VIEW_SALES_LEADS",
	EDIT_SALES_LEADS: "EDIT_SALES_LEADS",
	VIEW_DISPOSITIONS: "VIEW_DISPOSITIONS",
	VIEW_SALES_LEAD_CUSTOMERS: "VIEW_SALES_LEAD_CUSTOMERS",

	// Motivators
	VIEW_SALES_SPIFF_DEFINITIONS: "VIEW_SALES_SPIFF_DEFINITIONS",
	EDIT_SALES_SPIFF_DEFINITIONS: "EDIT_SALES_SPIFF_DEFINITIONS",
	VIEW_SERVICE_SPIFF_DEFINITIONS: "VIEW_SERVICE_SPIFF_DEFINITIONS",
	EDIT_SERVICE_SPIFF_DEFINITIONS: "EDIT_SERVICE_SPIFF_DEFINITIONS",
	VIEW_SALES_SPIFF_AWARDS: "VIEW_SALES_SPIFF_AWARDS",
	EDIT_SALES_SPIFF_AWARDS: "EDIT_SALES_SPIFF_AWARDS",
	VIEW_OPPORTUNITY_MINING: "VIEW_OPPORTUNITY_MINING",
	VIEW_SPECIAL_UNIT_LISTS: "VIEW_SPECIAL_UNIT_LISTS",
	EDIT_SPECIAL_UNIT_LISTS: "EDIT_SPECIAL_UNIT_LISTS",
	EDIT_OPPORTUNITY_MINING: "EDIT_OPPORTUNITY_MINING",
	EDIT_OPPORTUNITY_MINING_SETUP: "EDIT_OPPORTUNITY_MINING_SETUP",
	VIEW_SERVICE_SPIFF_AWARDS: "VIEW_SERVICE_SPIFF_AWARDS",
	EDIT_SERVICE_SPIFF_AWARDS: "EDIT_SERVICE_SPIFF_AWARDS",
	VIEW_SERVICES_TRAINING: "VIEW_SERVICES_TRAINING",
	EDIT_SERVICES_TRAINING: "EDIT_SERVICES_TRAINING",
	VIEW_SALES_TEMP_GUARANTEED: "VIEW_SALES_TEMP_GUARANTEED",
	VIEW_TEMP_GUARANTEED: "VIEW_TEMP_GUARANTEED",
	EDIT_TEMP_GUARANTEED: "EDIT_TEMP_GUARANTEED",
	EDIT_TEMP_GUARANTEED_SETUP: "EDIT_TEMP_GUARANTEED_SETUP",
	MASTER_EDIT_SALES_MOTIVATORS: "MASTER_EDIT_SALES_MOTIVATORS",
	MASTER_EDIT_SERVICE_MOTIVATORS: "MASTER_EDIT_SERVICE_MOTIVATORS",

	// Payroll
	VIEW_COMMISSION_CYCLE_CLOSING: "VIEW_COMMISSION_CYCLE_CLOSING",
	VIEW_WASHOUT_REVIEW: "VIEW_WASHOUT_REVIEW",
	OVERRIDE_SALES_ASSOCIATE_COMPENSATION: "OVERRIDE_SALES_ASSOCIATE_COMPENSATION",
	"OVERRIDE_F&I_MANAGER_COMPENSATION": "OVERRIDE_F&I_MANAGER_COMPENSATION",
	OVERRIDE_FINANCE_MANAGER_COMPENSATION: "OVERRIDE_F&I_MANAGER_COMPENSATION",
	OVERRIDE_SALES_MANAGER_COMPENSATION: "OVERRIDE_SALES_MANAGER_COMPENSATION",
	OVERRIDE_GENERAL_SALES_MANAGER_COMPENSATION: "OVERRIDE_GENERAL_SALES_MANAGER_COMPENSATION",
	OVERRIDE_FINANCE_DIRECTOR_COMPENSATION: "OVERRIDE_FINANCE_DIRECTOR_COMPENSATION",
	OVERRIDE_BDC_ASSOCIATE_COMPENSATION: "OVERRIDE_BDC_ASSOCIATE_COMPENSATION",
	OVERRIDE_BDC_MANAGER_COMPENSATION: "OVERRIDE_BDC_MANAGER_COMPENSATION",
	OVERRIDE_BDC_DIRECTOR_COMPENSATION: "OVERRIDE_BDC_DIRECTOR_COMPENSATION",
	OVERRIDE_BODY_SHOP_MANAGER_COMPENSATION: "OVERRIDE_BODY_SHOP_MANAGER_COMPENSATION",
	OVERRIDE_BODY_SHOP_PRODUCT_MANAGER_COMPENSATION: "OVERRIDE_BODY_SHOP_PRODUCT_MANAGER_COMPENSATION",
	OVERRIDE_BODY_SHOP_ESTIMATOR_COMPENSATION: "OVERRIDE_BODY_SHOP_ESTIMATOR_COMPENSATION",
	OVERRIDE_BODY_SHOP_TECHNICIAN_COMPENSATION: "OVERRIDE_BODY_SHOP_TECHNICIAN_COMPENSATION",
	OVERRIDE_BODY_SHOP_PAINTER_COMPENSATION: "OVERRIDE_BODY_SHOP_PAINTER_COMPENSATION",
	OVERRIDE_BODY_SHOP_FOREMAN_COMPENSATION: "OVERRIDE_BODY_SHOP_FOREMAN_COMPENSATION",
	OVERRIDE_PARTS_MANAGER_COMPENSATION: "OVERRIDE_PARTS_MANAGER_COMPENSATION",
	OVERRIDE_SERVICE_MANAGER_COMPENSATION: "OVERRIDE_SERVICE_MANAGER_COMPENSATION",
	OVERRIDE_SERVICE_DIRECTOR_COMPENSATION: "OVERRIDE_SERVICE_DIRECTOR_COMPENSATION",
	OVERRIDE_SERVICE_TECHNICIAN_COMPENSATION: "OVERRIDE_SERVICE_TECHNICIAN_COMPENSATION",
	OVERRIDE_SERVICE_ADVISOR_COMPENSATION: "OVERRIDE_SERVICE_ADVISOR_COMPENSATION",
	OVERRIDE_SERVICE_FOREMAN_COMPENSATION: "OVERRIDE_SERVICE_FOREMAN_COMPENSATION",
	OVERRIDE_INTERNAL_SERVICE_ADVISOR_COMPENSATION: "OVERRIDE_INTERNAL_SERVICE_ADVISOR_COMPENSATION",
	OVERRIDE_PARTS_DIRECTOR_COMPENSATION: "OVERRIDE_PARTS_DIRECTOR_COMPENSATION",
	OVERRIDE_PARTS_COUNTER_ASSOCIATE_COMPENSATION: "OVERRIDE_PARTS_COUNTER_ASSOCIATE_COMPENSATION",
	EDIT_WASHOUT_CHANGE_REQUEST: "EDIT_WASHOUT_CHANGE_REQUEST",
	RESOLVE_WASHOUT_CHANGE_REQUEST: "RESOLVE_WASHOUT_CHANGE_REQUEST",
	SUBMIT_PAYROLL: "SUBMIT_PAYROLL",
	REVIEW_BDC_ASSOCIATE_WASHOUTS: "REVIEW_BDC_ASSOCIATE_WASHOUTS",
	REVIEW_BDC_MANAGER_WASHOUTS: "REVIEW_BDC_MANAGER_WASHOUTS",
	REVIEW_BDC_DIRECTOR_WASHOUTS: "REVIEW_BDC_DIRECTOR_WASHOUTS",
	REVIEW_SALES_ASSOCIATE_WASHOUTS: "REVIEW_SALES_ASSOCIATE_WASHOUTS",
	REVIEW_FINANCE_MANAGER_WASHOUTS: "REVIEW_FINANCE_MANAGER_WASHOUTS",
	REVIEW_SALES_MANAGER_WASHOUTS: "REVIEW_SALES_MANAGER_WASHOUTS",
	REVIEW_GENERAL_SALES_MANAGER_WASHOUTS: "REVIEW_GENERAL_SALES_MANAGER_WASHOUTS",
	REVIEW_FINANCE_DIRECTOR_WASHOUTS: "REVIEW_FINANCE_DIRECTOR_WASHOUTS",
	REVIEW_GENERAL_MANAGER_WASHOUTS: "REVIEW_GENERAL_MANAGER_WASHOUTS",
	REVIEW_SERVICE_ADVISOR_WASHOUTS: "REVIEW_SERVICE_ADVISOR_WASHOUTS",
	REVIEW_INTERNAL_SERVICE_ADVISOR_WASHOUTS: "REVIEW_INTERNAL_SERVICE_ADVISOR_WASHOUTS",
	REVIEW_BODY_SHOP_ESTIMATOR_WASHOUTS: "REVIEW_BODY_SHOP_ESTIMATOR_WASHOUTS",
	REVIEW_SERVICE_TECHNICIAN_WASHOUTS: "REVIEW_SERVICE_TECHNICIAN_WASHOUTS",
	REVIEW_BODY_SHOP_TECHNICIAN_WASHOUTS: "REVIEW_BODY_SHOP_TECHNICIAN_WASHOUTS",
	REVIEW_PARTS_COUNTER_ASSOCIATE_WASHOUTS: "REVIEW_PARTS_COUNTER_ASSOCIATE_WASHOUTS",
	REVIEW_PARTS_MANAGER_WASHOUTS: "REVIEW_PARTS_MANAGER_WASHOUTS",
	REVIEW_PARTS_DIRECTOR_WASHOUTS: "REVIEW_PARTS_DIRECTOR_WASHOUTS",
	REVIEW_SERVICE_MANAGER_WASHOUTS: "REVIEW_SERVICE_MANAGER_WASHOUTS",
	REVIEW_SERVICE_DIRECTOR_WASHOUTS: "REVIEW_SERVICE_DIRECTOR_WASHOUTS",
	REVIEW_SERVICE_FOREMAN_WASHOUTS: "REVIEW_SERVICE_FOREMAN_WASHOUTS",
	REVIEW_BODY_SHOP_PAINTER_WASHOUTS: "REVIEW_BODY_SHOP_PAINTER_WASHOUTS",
	REVIEW_BODY_SHOP_MANAGER_WASHOUTS: "REVIEW_BODY_SHOP_MANAGER_WASHOUTS",
	REVIEW_BODY_SHOP_PRODUCT_MANAGER_WASHOUTS: "REVIEW_BODY_SHOP_PRODUCT_MANAGER_WASHOUTS",
	REVIEW_BODY_SHOP_DIRECTOR_WASHOUTS: "REVIEW_BODY_SHOP_DIRECTOR_WASHOUTS",
	REVIEW_BODY_SHOP_FOREMAN_WASHOUTS: "REVIEW_BODY_SHOP_FOREMAN_WASHOUTS",
	REVIEW_FIXED_OPERATIONS_DIRECTOR_WASHOUTS: "REVIEW_FIXED_OPERATIONS_DIRECTOR_WASHOUTS",

	// Special Access
	VIEW_SALES_LOG_SALES_MANAGER: "VIEW_SALES_LOG_SALES_MANAGER",
} as const;

export default ACTIONS;

export type Action = (typeof ACTIONS)[keyof typeof ACTIONS] | "" | "*";
